import {useOutletContext, useParams, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import { Client } from '../Api/Client';
import GraphSection from "../ContentSections/GraphSection";
import LinksSection from "../ContentSections/LinksSection";
import ContentSection from "../ContentSections/ContentSection";
import TableSection from "../ContentSections/TableSection";
import Spinner from "../Components/Spinner";
import BackButton from "../Components/BackButton";
import Page from "../Components/Page";
import {mapRoutesSvToEn} from "../Utils/routes";

function SkillsPage() {
    const [searchParams] = useSearchParams();
    const endpoint = `/pages/skills?${mapRoutesSvToEn(searchParams.toString())}`;

    return <Page endpoint={endpoint} showBackButton={true} />
}

export default SkillsPage;